module.exports = "/packs/media/images/family_2-d858dc69910ad3a8c57e80d72f28029b.jpg";